import repository from "@/plugins/axios/publicClient";

export default {
  env() {
    return repository.get("/env");
  },
  async login(payload) {
    await repository.get("/env");
    return repository.post("/login", payload);
  },
  logout() {
    return repository.post("/logout");
  },
  async forgotPassword(payload) {
    await repository.get("/env");
    return repository.post("/forgot-password", payload);
  },
  async resetPassword(payload) {
    await repository.get("/env");
    return repository.post("/reset-password", payload);
  },
  async registerUser(payload) {
    await repository.get("/env");
    return repository.post("/register", payload);
  },
  sendVerification(payload) {
    return repository.post("/email/verification-notification", payload);
  }
};
